//import axios from 'axios'
import axios from '../../services/services'
import * as actionTypes from './actionTypes'

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    }
}

export const authSuccess = (token,email) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        token: token,
        email: email
    }
}

export const authFacebookUrl = (url) =>{
    return {
        type: actionTypes.SET_AUTH_FACEBOOKURL,
        facebookUrl: url,
    }
}

export const authGoogleUrl = (url) =>{
    return {
        type:actionTypes.SET_AUTH_GOOGLEURL,
        googleUrl:url
    }
}

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    }
}

export const logout = () => {
    return {
        type: actionTypes.AUTH_LOGOUT
    }
}

export const checkAuthTimeout = (expirationTime) => {

    return dispatch => {
        setTimeout(() => { 
            dispatch(logout())
        }, expirationTime * 1000)
    }

}

export const auth = (email, password) => {
    return dispatch => {
        const formData = new FormData()
        formData.append('email',email)
        formData.append('password',password)
      
        dispatch(authStart())
        axios.userServices.loginUser(formData)
            .then(response => {
                const expirationDate = new Date(new Date().getTime() + response.data.result.expires_at  * 1000)
                localStorage.setItem('token', response.data.result.access_token)
                localStorage.setItem('expirationDate', expirationDate)
                localStorage.setItem('email', response.data.result.user.email)
                dispatch(authSuccess(response.data.result.access_token, response.data.result.user.email))
                dispatch(checkAuthTimeout(response.data.result.expires_at))
            })
            .catch(err => {
                if(err.hasOwnProperty("response")){
                    dispatch(authFail(err.response.data.result))
                }
            })
    }

}

export const authGoogle = () =>{
    return dispatch =>{
        dispatch(authStart())
        axios.userServices.loginGoogle()
        .then(response=>{
            console.log(response)
            dispatch(authGoogleUrl(response.data))
            //localStorage.setItem('token', token)
        })
        .catch(err => {
            if(err.hasOwnProperty("response")){
                dispatch(authFail(err.response.data.result))
            }
        })

    }
}

export const authFacebook = () => {
    return dispatch => {
        dispatch(authStart())
        axios.userServices.loginFacebook()
        .then(response=>{
            console.log(response)
            dispatch(authFacebookUrl(response.data))
            //localStorage.setItem('token', token)
        })
        .catch(err => {
            if(err.hasOwnProperty("response")){
                dispatch(authFail(err.response.data.result))
            }
        })
    }
}


export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    }
}

export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token')
        if (!token) {
            dispatch(logout())
        } else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'))
            if (expirationDate <= new Date()) {
                dispatch(logout())
            } else {
                const email = localStorage.getItem('email')
                dispatch(authSuccess(token, email))
                dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000 ))
            }   
        }
    }
}

